/*@flow*/
import type { Element } from 'react'; /** @jsx jsx */
import { css, jsx } from '@emotion/core';
import useCommands from './useCommands';

export default function LTCloseButton({
  color = "#333",
}: {
  color?: string,
}): Element<string> {
  const cmd = useCommands();
  const onClick = () => cmd.closePanel();
  return (
    <button
      className="p-0 d-flex align-items-center"
      css={css(`color: ${color};`)}
      onClick={onClick}
    >
      <i className="fa fa-times" />
    </button>
  );
}
